export class Gesamtsummen {
    // BT-106
    summePositionenNetto = null
    // BT-107 - optional
    summeAbschlaegeNetto = null
    // BT-108 - optional
    summeZuschlaegeNetto = null
    // BT-109
    gesamtsummeNetto = null
    // BT-110
    summeUmsatzsteuer = null

    // BT-111 - Nach Abstimmungen in Rahmen von EPE-1210 entfernt, siehe Kommentar in https://jira.de.nortal.com/browse/EPE-1210

    // BT-112
    gesamtsummeBrutto = null
    // BT-113 - optional
    gezahlterBetrag = null
    // BT-114 - optional
    rundungsBetrag = null
    // BT-115
    faelligerBetrag = null

    toJSON() {
        return {
            summePositionenNetto: this.nullCheck(Number(this.summePositionenNetto)?.toFixed(2)),
            summeAbschlaegeNetto: this.nullCheck(Number(this.summeAbschlaegeNetto)?.toFixed(2)),
            summeZuschlaegeNetto: this.nullCheck(Number(this.summeZuschlaegeNetto)?.toFixed(2)),
            gesamtsummeNetto: this.nullCheck(Number(this.gesamtsummeNetto)?.toFixed(2)),
            summeUmsatzsteuer: this.nullCheck(Number(this.summeUmsatzsteuer)?.toFixed(2)),
            gesamtsummeBrutto: this.nullCheck(Number(this.gesamtsummeBrutto)?.toFixed(2)),
            gezahlterBetrag: this.nullCheck(Number(this.gezahlterBetrag)?.toFixed(2)),
            rundungsBetrag: this.nullCheck(Number(this.rundungsBetrag)?.toFixed(2)),
            faelligerBetrag: this.nullCheck(Number(this.faelligerBetrag)?.toFixed(2)),
        }
    }

    toJSONWithoutNullCheck() {
        return {
            summePositionenNetto: Number(this.summePositionenNetto)?.toFixed(2),
            summeAbschlaegeNetto: Number(this.summeAbschlaegeNetto)?.toFixed(2),
            summeZuschlaegeNetto: Number(this.summeZuschlaegeNetto)?.toFixed(2),
            gesamtsummeNetto: Number(this.gesamtsummeNetto)?.toFixed(2),
            summeUmsatzsteuer: Number(this.summeUmsatzsteuer)?.toFixed(2),
            gesamtsummeBrutto: Number(this.gesamtsummeBrutto)?.toFixed(2),
            gezahlterBetrag: Number(this.gezahlterBetrag)?.toFixed(2),
            rundungsBetrag: Number(this.rundungsBetrag)?.toFixed(2),
            faelligerBetrag: Number(this.faelligerBetrag)?.toFixed(2),
        }
    }

    nullCheck(value: any) {
        return value === null ? 0 : value
    }
}
